export const GET_RECORD_TASK_VIDEO = 'GET_RECORD_TASK_VIDEO';
export const RECORD_TASK_VIDEO_RESPONSE = 'RECORD_TASK_VIDEO_RESPONSE';
export const RESET_TASK_VIDEO = 'RESET_TASK_VIDEO';
